(() => {
  'use strict';

  const script = document.querySelector('[data-ap-r2500-variant-details]');
  if (!script) return;

  let config;
  try {
    config = JSON.parse(script.textContent);
  } catch (error) {
    console.error('[R2500 details] Invalid configuration JSON.', error);
    return;
  }

  const variantMap = new Map((config.variants || []).map((variant) => [String(variant.id), variant]));
  const contentMap = config.content || {};
  const defaultVersion = config.defaultVersion || 'r2500_plus';

  const selectors = {
    title: '.product__title h1',
    description: '.product__description .rte',
    introSection: '[id$="__text_LcjAEp"]',
    powerSection: '[id$="__image_with_text_P6E3Lc"]',
    featureSection: '[id$="__icon_with_text_BNbT9E"]',
    faqSection: '[id$="__collapsible_content_WJtXP3"]',
    calculatorSection: '[id$="__power_calculator_bnRczf"]'
  };

  const original = {};
  let originalsCaptured = false;

  function first(selector, root = document) {
    return root.querySelector(selector);
  }

  function all(selector, root = document) {
    return Array.from(root.querySelectorAll(selector));
  }

  function captureOriginals() {
    if (originalsCaptured) return;

    const title = first(selectors.title);
    const descriptions = all(selectors.description);
    const intro = first(selectors.introSection);
    const power = first(selectors.powerSection);
    const feature = first(selectors.featureSection);
    const faq = first(selectors.faqSection);

    original.title = title?.innerHTML || '';
    original.descriptions = descriptions.map((node) => node.innerHTML);

    original.introTextNode = intro ? first('.s-header__desc', intro) : null;
    original.introText = original.introTextNode?.innerHTML || '';

    original.powerHeadingNode = power ? first('.s-header__title', power) : null;
    original.powerHeading = original.powerHeadingNode?.innerHTML || '';

    const featureItems = feature ? all('[role="listitem"]', feature) : [];
    original.capacityFeatureHeadingNode = featureItems.length ? first('h3', featureItems[0]) : null;
    original.capacityFeatureTextNode = featureItems.length ? first('.text-block', featureItems[0]) : null;
    original.capacityFeatureHeading = original.capacityFeatureHeadingNode?.innerHTML || '';
    original.capacityFeatureText = original.capacityFeatureTextNode?.innerHTML || '';

    const faqBodies = faq ? all('.js-accordion-content', faq) : [];
    original.faqRuntimeNode = faqBodies[0] || null;
    original.faqPowerNode = faqBodies[1] || null;
    original.faqRuntime = original.faqRuntimeNode?.innerHTML || '';
    original.faqPower = original.faqPowerNode?.innerHTML || '';

    originalsCaptured = true;
  }

  function restorePlus() {
    const title = first(selectors.title);
    const descriptions = all(selectors.description);

    if (title) title.innerHTML = original.title;
    descriptions.forEach((node, index) => {
      if (typeof original.descriptions[index] === 'string') node.innerHTML = original.descriptions[index];
    });

    if (original.introTextNode) original.introTextNode.innerHTML = original.introText;
    if (original.powerHeadingNode) original.powerHeadingNode.innerHTML = original.powerHeading;
    if (original.capacityFeatureHeadingNode) original.capacityFeatureHeadingNode.innerHTML = original.capacityFeatureHeading;
    if (original.capacityFeatureTextNode) original.capacityFeatureTextNode.innerHTML = original.capacityFeatureText;
    if (original.faqRuntimeNode) original.faqRuntimeNode.innerHTML = original.faqRuntime;
    if (original.faqPowerNode) original.faqPowerNode.innerHTML = original.faqPower;

    updateCalculator(2016, 2500);
  }

  function applyV2(content) {
    const title = first(selectors.title);
    const descriptions = all(selectors.description);

    if (title && content.title) title.textContent = content.title;
    descriptions.forEach((node) => {
      if (content.descriptionHtml) node.innerHTML = content.descriptionHtml;
    });

    if (original.introTextNode && content.introText) {
      original.introTextNode.innerHTML = `<p>${content.introText}</p>`;
    }
    if (original.powerHeadingNode && content.powerHeading) {
      original.powerHeadingNode.textContent = content.powerHeading;
    }
    if (original.capacityFeatureHeadingNode && content.capacityFeatureHeading) {
      original.capacityFeatureHeadingNode.textContent = content.capacityFeatureHeading;
    }
    if (original.capacityFeatureTextNode && content.capacityFeatureText) {
      original.capacityFeatureTextNode.innerHTML = `<p>${content.capacityFeatureText}</p>`;
    }
    if (original.faqRuntimeNode && content.faqRuntimeHtml) {
      original.faqRuntimeNode.innerHTML = content.faqRuntimeHtml;
    }
    if (original.faqPowerNode && content.faqPowerHtml) {
      original.faqPowerNode.innerHTML = content.faqPowerHtml;
    }

    updateCalculator(content.runtimeCapacity || 1920, content.runtimeMaxPower || 2500);
  }

  function updateCalculator(capacity, maxPower) {
    const section = first(selectors.calculatorSection);
    if (!section) return;

    section.dispatchEvent(new CustomEvent('ap:power-calculator-update', {
      bubbles: true,
      detail: { capacity, maxPower }
    }));
  }

  function resolveVersion(variant) {
    const metafieldValue = (variant?.detailVersion || '').trim();
    if (metafieldValue) return metafieldValue;

    const title = (variant?.title || '').toLowerCase();
    if (title.includes('v2') || title.includes('1920')) return 'r2500_v2';
    return defaultVersion;
  }

  function applyVariant(variantId) {
    captureOriginals();

    const variant = variantMap.get(String(variantId));
    const version = resolveVersion(variant);
    document.body.dataset.apR2500Version = version;

    if (version === 'r2500_v2') {
      applyV2(contentMap.r2500_v2 || {});
    } else {
      restorePlus();
    }
  }

  function currentVariantId() {
    const checked = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (checked?.value) return checked.value;

    const fromUrl = new URL(window.location.href).searchParams.get('variant');
    return fromUrl || '';
  }

  function init() {
    captureOriginals();
    applyVariant(currentVariantId());

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;

      if (target.matches('input[name="id"], select[name="id"], .js-variant-item')) {
        window.setTimeout(() => applyVariant(currentVariantId()), 0);
      }
    });

    window.addEventListener('popstate', () => applyVariant(currentVariantId()));

    document.addEventListener('shopify:section:load', () => {
      originalsCaptured = false;
      window.setTimeout(() => {
        captureOriginals();
        applyVariant(currentVariantId());
      }, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
